import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorMessage } from '../../../api';
import { getBookingByIdApi, getBookingDetailSeatApi } from '../../../api/booking';
import { Constant } from '../../../config/constant';
import { BookingsState, getBookingByIdType } from '../../../types/booking';
import { RootState } from '../../store';
// @ts-ignore

export const getListBookingDetail = createAsyncThunk(
  'admin/listBookingDetailTicket',
  async (params: getBookingByIdType, { dispatch, rejectWithValue }) => {
    try {
      const response = await getBookingByIdApi(params);
      const { data, status } = response;
      if (status === Constant.DEFAULT_STATUS) {
        dispatch(setListBookingDetail(data));
        return true;
      }
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
    return false;
  },
);
export const getBookingDetailSeat = createAsyncThunk(
  'admin/listBookingDetailSeatTicket',
  async (params: getBookingByIdType, { dispatch, rejectWithValue }) => {
    try {
      const response = await getBookingDetailSeatApi(params);
      const { data, status } = response;
      if (status === Constant.DEFAULT_STATUS) {
        dispatch(setListBookingDetailSeat(data));
        return true;
      }
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
    return false;
  },
);

export const listDetailTicketSlice = createSlice({
  name: 'listDetailTicket',
  initialState: {
    error: false,
    loading: false,
    success: false,
    listBooking: [],
    pagination: [],
    paginationHistory: [],
    status: 0,
    message: '',
    listBookingDetail: {},
    listBookingDetailSeat: {},
    seat_number: undefined,
    errorDetail: null,
  } as BookingsState,
  reducers: {
    setListBookingDetail: (state: BookingsState, { payload }) => {
      state.listBookingDetail = payload?.data;
    },
    setListBookingDetailSeat: (state: BookingsState, { payload }) => {
      state.listBookingDetailSeat = payload?.data;
      state.seat_number = payload?.seat_number;
    },
    resetListBookingDetail: (state: BookingsState) => {
      state.listBooking = [];
      state.listBookingDetail = {};
      state.listBookingDetailSeat = {};
      state.bookingData = [];
      state.seat_number = undefined;
    },
    resetListBookingTicket: (state: BookingsState) => {
      state.listBookingDetail = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getListBookingDetail.pending, (state: BookingsState) => {
      state.loadingListBooking = true;
    });
    builder.addCase(getListBookingDetail.fulfilled, (state: BookingsState) => {
      state.loadingListBooking = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(getListBookingDetail.rejected, (state: BookingsState) => {
      state.loadingListBooking = false;
      state.success = false;
      state.error = true;
    });
    builder.addCase(getBookingDetailSeat.pending, (state: BookingsState) => {
      state.loading = true;
    });
    builder.addCase(getBookingDetailSeat.fulfilled, (state: BookingsState) => {
      state.loading = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(getBookingDetailSeat.rejected, (state: BookingsState) => {
      state.loading = false;
      state.success = false;
      state.error = true;
    });
  },
});

export const listDetailTicketSelector = (state: RootState) => state.listDetailTicket;
export const { setListBookingDetail, resetListBookingDetail, setListBookingDetailSeat, resetListBookingTicket } =
  listDetailTicketSlice.actions;
